// extracted by mini-css-extract-plugin
module.exports = {"box":"antd-pro-pages-user-components-box-style-box"};